import { render, staticRenderFns } from "./GraficoArvoresUteis.vue?vue&type=template&id=61551dc0&scoped=true"
import script from "./GraficoArvoresUteis.vue?vue&type=script&lang=js"
export * from "./GraficoArvoresUteis.vue?vue&type=script&lang=js"
import style0 from "./GraficoArvoresUteis.vue?vue&type=style&index=0&id=61551dc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61551dc0",
  null
  
)

export default component.exports